module.exports = __webpack_public_path__ + "img/DarkWaddiLogo.16a92e0e.svg";